import {  ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from 'src/app/services/auth.service';
import { CompressImageService } from 'src/app/services/compress-image.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit, OnDestroy {
  public type = 'password';
  public form: FormGroup;
  public submitted = false;

  private subs = new Subscription();
  public imageUrl: any;
  @ViewChild('fileInput') el: ElementRef;
  private $imageCompressed = new EventEmitter()
  
  constructor(
    public authService: AuthService,
    public fb: FormBuilder,
    private changes: ChangeDetectorRef,
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private compressService: CompressImageService,
  ) { }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      instagram: new FormControl('invertedcrossfit', [Validators.required]),
      email: new FormControl('angelcamacho1708+411@gmail.com', [Validators.required, Validators.email]),
      repeatedEmail: new FormControl('angelcamacho1708+411@gmail.com', [Validators.required, Validators.email]),
      // password: new FormControl(null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,}')]),
      password: new FormControl('1234567', [Validators.required, Validators.min(7)]),
      repeatedPassword: new FormControl('1234567', [Validators.required]),
      priceRange: new FormControl('expensive', [Validators.required]),
      photoURL: new FormControl(null, [Validators.required]),
    })
    this.subs = this.$imageCompressed.subscribe((compressedImage: any) => {
      let reader = new FileReader(); // HTML5 FileReader API
      // now you can do upload the compressed image 
      reader.readAsDataURL(compressedImage);
      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.imageUrl = reader.result
        this.form.patchValue({
          photoURL: reader.result
        });
        this.changes.detectChanges();
      }
    });
  }

  public passwordsMatch(): boolean {
    return (this.form.controls.repeatedPassword.touched && this.form.controls.password.touched) && (this.form.controls.repeatedPassword.value !== this.form.controls.password.value)
  }

  public mailsMatch(): boolean {
    return (this.form.controls.repeatedEmail.touched && this.form.controls.email.touched) && (this.form.controls.repeatedEmail.value !== this.form.controls.email.value)
  }

  public onViewPassword(): void {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  public async submit(): Promise<any> {
    this.submitted = true;
    this.authService.signUp(this.form.controls.email.value, 
      this.form.controls.password.value, this.form.controls.instagram.value, 
       this.form.controls.priceRange.value,this.form.controls.photoURL.value )
    .then((res)=>{
          this.authService.sendVerificationMail();
          this.submitted = false;
    })
    .catch(()=>{
      this.submitted = false;
     })
  }

  public deleteImage(): void {
    this.imageUrl = null;
    this.form.patchValue({
      photoURL: null
    });
  }

  public uploadFile(event: any) {
    let file = event.target.files[0];

    if (event.target.files && event.target.files[0]) {
      this.compressImage(file)
    }
  }

  private compressImage(file: File): void {

    this.compressService.compress(file)
    .pipe(take(1))
    .subscribe((compressedImage: any) => {
      this.$imageCompressed.next(compressedImage)
      return;
    })
  }


}

